import { render, staticRenderFns } from "./RequirementChart.vue?vue&type=template&id=fb4ccc1c&scoped=true&lang=html&"
import script from "./RequirementChart.vue?vue&type=script&lang=js&"
export * from "./RequirementChart.vue?vue&type=script&lang=js&"
import style0 from "./RequirementChart.vue?vue&type=style&index=0&id=fb4ccc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4ccc1c",
  null
  
)

export default component.exports